import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider, message } from "antd";
import "@/services/loadMomentLocale";
import zhCN from "antd/lib/locale-provider/zh_CN";
import "antd/dist/antd.css";
import "./index.less";

message.config({
  duration: 6,
});

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Router>
      <App />
    </Router>
  </ConfigProvider>,
  document.getElementById("root")
);
